import React from 'react';
import Helmet from 'react-helmet';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import moment from 'moment'

export default class Example extends React.Component {
  static defaultProps = {
    numberOfMonths: 2,
  };

  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      from: this.props.values.from,
      to: this.props.values.to,
    };
  }

  async handleDayClick(day) {
    const range = DateUtils.addDayToRange(day, this.state);
    await this.setState(range);
    this.props.handleChange({startDate: this.state.from, endDate: this.state.to})
  }

  async handleResetClick() {
    await this.props.handleChange({startDate: undefined, endDate: undefined})
    this.setState(this.getInitialState())
  }

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    return (
      <div className="RangeExample">
        <DayPicker
          className="Selectable"
          fromMonth={moment(new Date()).subtract(5, 'years').toDate()}
          toMonth={moment(new Date()).add(6, 'months').toDate()}
          month={moment(new Date()).subtract(1, 'months').toDate()}
          numberOfMonths={3}
          selectedDays={[from, { from, to }]}
          modifiers={modifiers}
          onDayClick={this.handleDayClick}
        />
        <a style={{ fontSize: 10, opacity: 0.5, cursor: 'pointer', display: "block" }} onClick={this.handleResetClick}>
          Auswahl zurücksetzen
        </a>
      <Helmet>
        <style>{`
        @media (max-width: 990px) {
          .mobile-no-padding{
            padding: 15px;
          }
        }
        .DayPicker-Months {
          justify-content: space-between;
        }

        .DayPicker-Month{
          width: 30%;
        }
        .DayPicker-Month:last-child {
        margin-right: 0;
        }

        .DayPicker{
          width: 100%;
        }
        .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
          background-color: #dab77775 !important;
          color: white !important;
        }
          .Selectable .DayPicker-Day {
            border-radius: 0 !important;
          }
          .Selectable .DayPicker-Day--start {
            border-top-left-radius: 0px !important;
            border-bottom-left-radius: 0px !important;
          }
          .Selectable .DayPicker-Day--end {
            border-top-right-radius: 0px !important;
            border-bottom-right-radius: 0px !important;
          }
          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
            background-color: #212D3D;
        }
        .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
          background-color: #dab77775;
        }
        .DayPicker *:focus {
          outline: none;
        }
        `}</style>
      </Helmet>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /src/components/admin/AnalyticsDayPicker.js